function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.DeleteImage20{fill:#37BEB7;stroke:#FFBE54;stroke-miterlimit:10;}\n\t.DeleteImage21{fill:#8E384E;}\n");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "DeleteImage20",
  cx: 11.2,
  cy: 17.8,
  r: 2.6
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "DeleteImage20",
  d: "M22.5,13.2V5.2L17.3,0H0v30h22.5v-0.1c4.2-0.5,7.5-4,7.5-8.4C30,17.2,26.7,13.6,22.5,13.2z M16.9,2.3l3.4,3.4 h-3.4L16.9,2.3z M1.9,28.1V1.9H15v5.6h5.6v5.7c-0.8,0.1-1.6,0.3-2.3,0.6c-0.5-0.6-1.4-0.6-1.4-0.6H15l-1.9-1.9H9.4l-1.9,1.9H5.6 c0,0-1.9,0-1.9,1.9v5.6c0,1.9,1.9,1.9,1.9,1.9s4.2,0,7.6,0c0.3,2.3,1.4,4.3,3.1,5.6H1.9z M14.1,17.7c-0.3,0.6-0.6,1.3-0.7,1.9 c-0.5,0.6-1.3,1-2.1,1c-1.6,0-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8C12.8,15,14,16.2,14.1,17.7z M21.6,28.1 c-3.6,0-6.6-2.9-6.6-6.6c0-3.6,2.9-6.6,6.6-6.6c3.6,0,6.6,2.9,6.6,6.6C28.1,25.2,25.2,28.1,21.6,28.1z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 17.6,
  y: 20.2,
  className: "DeleteImage21",
  width: 8,
  height: 2.7
})));

var SvgDeleteImage2 = function SvgDeleteImage2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteImage2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DeleteImage2.b2c15c56.svg";
export { ForwardRef as ReactComponent };